/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  /** Limit custom scalar type */
  Limit: { input: any; output: any; }
};

export type AddFloorPlanFeedbackInput = {
  description: Scalars['String']['input'];
  feedbackType: FeedBackTypeEnum;
  floorPlanDetectionId?: InputMaybe<Scalars['ID']['input']>;
  floorPlanId: Scalars['ID']['input'];
};

export type AddFloorPlanFeedbackWebInput = {
  description: Scalars['String']['input'];
  feedbackType: FeedBackTypeEnum;
  floorPlanDetectionId?: InputMaybe<Scalars['ID']['input']>;
  floorPlanId: Scalars['ID']['input'];
};

export type Annotation = {
  __typename?: 'Annotation';
  detections?: Maybe<Array<Maybe<AnnotationDetection>>>;
  image?: Maybe<Scalars['String']['output']>;
  parentTypes?: Maybe<Array<Maybe<AnnotationParentType>>>;
  uuid?: Maybe<Scalars['ID']['output']>;
};

export type AnnotationDetection = {
  __typename?: 'AnnotationDetection';
  bbox?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  childID?: Maybe<Scalars['String']['output']>;
  childType?: Maybe<Scalars['String']['output']>;
  confidence?: Maybe<Scalars['Float']['output']>;
  parentID?: Maybe<Scalars['String']['output']>;
  parentType?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type AnnotationDetectionInput = {
  bbox?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  childID?: InputMaybe<Scalars['String']['input']>;
  childType?: InputMaybe<Scalars['String']['input']>;
  confidence?: InputMaybe<Scalars['Float']['input']>;
  parentID?: InputMaybe<Scalars['String']['input']>;
  parentType?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type AnnotationParentType = {
  __typename?: 'AnnotationParentType';
  bbox?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  parentID?: Maybe<Scalars['String']['output']>;
  parentType?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type Asset = {
  __typename?: 'Asset';
  angle?: Maybe<Scalars['Float']['output']>;
  category?: Maybe<CategoryEnum>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  direction?: Maybe<EntranceDirectionEnum>;
  height?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
  xAxis?: Maybe<Scalars['Float']['output']>;
  yAxis?: Maybe<Scalars['Float']['output']>;
};

export enum CardinalDirectionEnum {
  East = 'EAST',
  EastNorthEast = 'EAST_NORTH_EAST',
  EastSouthEast = 'EAST_SOUTH_EAST',
  North = 'NORTH',
  NorthEast = 'NORTH_EAST',
  NorthNorthEast = 'NORTH_NORTH_EAST',
  NorthNorthWest = 'NORTH_NORTH_WEST',
  NorthWest = 'NORTH_WEST',
  South = 'SOUTH',
  SouthEast = 'SOUTH_EAST',
  SouthSouthEast = 'SOUTH_SOUTH_EAST',
  SouthSouthWest = 'SOUTH_SOUTH_WEST',
  SouthWest = 'SOUTH_WEST',
  West = 'WEST',
  WestNorthWest = 'WEST_NORTH_WEST',
  WestSouthWest = 'WEST_SOUTH_WEST'
}

export enum CategoryEnum {
  Base = 'BASE',
  Entrance = 'ENTRANCE',
  FloorPlanPdf = 'FLOOR_PLAN_PDF',
  NorthDirected = 'NORTH_DIRECTED'
}

export type Color = {
  __typename?: 'Color';
  high: Scalars['String']['output'];
  low: Scalars['String']['output'];
  medium: Scalars['String']['output'];
};

export type ColorCodes = {
  __typename?: 'ColorCodes';
  confidenceColors: Color;
  severityColors: Color;
};

export type CommonMessageResponse = {
  __typename?: 'CommonMessageResponse';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export enum EntranceDirectionEnum {
  Bottom = 'BOTTOM',
  Left = 'LEFT',
  Right = 'RIGHT',
  Top = 'TOP'
}

export enum FeedBackTypeEnum {
  IncorrectObjectDetection = 'INCORRECT_OBJECT_DETECTION',
  Other = 'OTHER',
  ScoreSeemsInaccurate = 'SCORE_SEEMS_INACCURATE'
}

export type Filter = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SortBy>;
};

export type FloorPlan = {
  __typename?: 'FloorPlan';
  address?: Maybe<Scalars['String']['output']>;
  annotation?: Maybe<Annotation>;
  assets?: Maybe<Array<Maybe<Asset>>>;
  companyName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  floorNumber?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  propertyType?: Maybe<Scalars['String']['output']>;
  resultScore?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<FloorPlanEnum>;
  totalScore?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type FloorPlanDetection = {
  __typename?: 'FloorPlanDetection';
  bbox?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  childId?: Maybe<Scalars['String']['output']>;
  childType?: Maybe<Scalars['String']['output']>;
  confidence?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  detectionImage?: Maybe<Scalars['String']['output']>;
  direction?: Maybe<CardinalDirectionEnum>;
  id?: Maybe<Scalars['ID']['output']>;
  issue?: Maybe<Scalars['Boolean']['output']>;
  parentId?: Maybe<Scalars['String']['output']>;
  parentType?: Maybe<Scalars['String']['output']>;
  resultScore?: Maybe<Scalars['Float']['output']>;
  severity?: Maybe<SeverityEnum>;
  title?: Maybe<Scalars['String']['output']>;
  totalScore?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type FloorPlanDetectionTitlesResponse = {
  __typename?: 'FloorPlanDetectionTitlesResponse';
  Id?: Maybe<Scalars['ID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export enum FloorPlanEnum {
  AnnotationProcessing = 'ANNOTATION_PROCESSING',
  AnnotationSuccess = 'ANNOTATION_SUCCESS',
  Draft = 'DRAFT',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Success = 'SUCCESS'
}

export type FloorPlanFeedbackInput = {
  __typename?: 'FloorPlanFeedbackInput';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  feedbackType: FeedBackTypeEnum;
  floorPlanDetectionId?: Maybe<Scalars['ID']['output']>;
  floorPlanId?: Maybe<Scalars['ID']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type FloorPlanReportResponse = {
  __typename?: 'FloorPlanReportResponse';
  message?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type FloorPlanReportWebResponse = {
  __typename?: 'FloorPlanReportWebResponse';
  message?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type FloorPlanResponse = {
  __typename?: 'FloorPlanResponse';
  data?: Maybe<FloorPlan>;
  message?: Maybe<Scalars['String']['output']>;
};

export type FloorPlanStaticData = {
  __typename?: 'FloorPlanStaticData';
  allowedChildrenElements?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  allowedParentElements?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  description?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type FloorPlanWebResponse = {
  __typename?: 'FloorPlanWebResponse';
  data?: Maybe<FloorPlan>;
  message?: Maybe<Scalars['String']['output']>;
};

export type FloorPlanWithDetectionsResponse = {
  __typename?: 'FloorPlanWithDetectionsResponse';
  data?: Maybe<Array<Maybe<FloorPlanDetection>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type FloorPlanWithDetectionsWebResponse = {
  __typename?: 'FloorPlanWithDetectionsWebResponse';
  data?: Maybe<Array<Maybe<FloorPlanDetection>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type FloorPlansResponse = {
  __typename?: 'FloorPlansResponse';
  data?: Maybe<Array<Maybe<FloorPlan>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type FloorPlansWebResponse = {
  __typename?: 'FloorPlansWebResponse';
  data?: Maybe<Array<Maybe<FloorPlan>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type GenerateAnnotationInput = {
  floorPlanId?: InputMaybe<Scalars['ID']['input']>;
};

export type GenerateAnnotationResponse = {
  __typename?: 'GenerateAnnotationResponse';
  data?: Maybe<FloorPlan>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type GenerateAnnotationWebInput = {
  floorPlanId?: InputMaybe<Scalars['ID']['input']>;
};

export type GenerateAnnotationWebResponse = {
  __typename?: 'GenerateAnnotationWebResponse';
  data?: Maybe<FloorPlan>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type GetColorCodesWebResponse = {
  __typename?: 'GetColorCodesWebResponse';
  confidenceColors: Color;
  severityColors: Color;
};

export type GetDetectionsByFloorPlanInput = {
  floorPlanId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SortBy>;
};

export type GetDetectionsByFloorPlanWebInput = {
  floorPlanId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SortBy>;
};

export type GetFloorPlanBaseImageUploadSignedUrlInput = {
  fileName: Scalars['String']['input'];
};

export type GetFloorPlanDetectionTitlesInput = {
  floorPlanId: Scalars['ID']['input'];
};

export type GetFloorPlanStaticDataResponse = {
  __typename?: 'GetFloorPlanStaticDataResponse';
  data?: Maybe<Array<Maybe<FloorPlanStaticData>>>;
  status?: Maybe<Scalars['String']['output']>;
};

export type GetImageSignedUrlInput = {
  fileName: Scalars['String']['input'];
  s3Path: S3PathEnum;
};

export type GetImageSignedUrlWebInput = {
  fileName: Scalars['String']['input'];
  s3Path: S3PathEnum;
};

export type IsPhoneNoExistInput = {
  countryCode: Scalars['String']['input'];
  phoneNo: Scalars['String']['input'];
};

export type IsPhoneNoExistResponse = {
  __typename?: 'IsPhoneNoExistResponse';
  phoneNoExist?: Maybe<Scalars['Boolean']['output']>;
};

export type IsPhoneNoExistWebInput = {
  countryCode: Scalars['String']['input'];
  phoneNo: Scalars['String']['input'];
};

export type IsPhoneNoExistWebResponse = {
  __typename?: 'IsPhoneNoExistWebResponse';
  phoneNoExist?: Maybe<Scalars['Boolean']['output']>;
};

export type LoginInputData = {
  countryCode: Scalars['String']['input'];
  deviceInfo: DeviceInfo;
  otpLessVerificationToken: Scalars['String']['input'];
  phoneNo: Scalars['String']['input'];
};

export type LoginResponse = {
  __typename?: 'LoginResponse';
  accessToken?: Maybe<Scalars['String']['output']>;
  data?: Maybe<User>;
  message?: Maybe<Scalars['String']['output']>;
  refreshToken?: Maybe<Scalars['String']['output']>;
};

export type LoginWebInputData = {
  countryCode: Scalars['String']['input'];
  deviceInfo: DeviceInfo;
  otpLessVerificationToken: Scalars['String']['input'];
  phoneNo: Scalars['String']['input'];
};

export type LoginWebResponse = {
  __typename?: 'LoginWebResponse';
  accessToken?: Maybe<Scalars['String']['output']>;
  data?: Maybe<User>;
  message?: Maybe<Scalars['String']['output']>;
  refreshToken?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addFloorPlanFeedback?: Maybe<CommonMessageResponse>;
  addFloorPlanFeedbackWeb?: Maybe<CommonMessageResponse>;
  deleteAccount?: Maybe<CommonMessageResponse>;
  deleteAccountWeb?: Maybe<CommonMessageResponse>;
  deleteFloorPlan?: Maybe<CommonMessageResponse>;
  deleteFloorPlanWeb?: Maybe<CommonMessageResponse>;
  floorPlanFeedback?: Maybe<CommonMessageResponse>;
  generateAnnotation?: Maybe<GenerateAnnotationResponse>;
  generateAnnotationWeb?: Maybe<GenerateAnnotationWebResponse>;
  login?: Maybe<LoginResponse>;
  loginWeb?: Maybe<LoginWebResponse>;
  logout?: Maybe<CommonMessageResponse>;
  logoutWeb?: Maybe<CommonMessageResponse>;
  refreshToken?: Maybe<RefreshTokenResponse>;
  refreshTokenWeb?: Maybe<RefreshTokenWebResponse>;
  updateAndSubmitAnnotation?: Maybe<UpdateAndSubmitAnnotationResponse>;
  updateAndSubmitAnnotationWeb?: Maybe<UpdateAndSubmitAnnotationResponse>;
  updateFloorPlan?: Maybe<FloorPlanResponse>;
  updateFloorPlanWeb?: Maybe<FloorPlanWebResponse>;
  updateUser?: Maybe<UserResponse>;
  updateUserWeb?: Maybe<UserWebResponse>;
  uploadFloorPlan?: Maybe<FloorPlanResponse>;
  uploadFloorPlanWeb?: Maybe<FloorPlanWebResponse>;
};


export type MutationAddFloorPlanFeedbackArgs = {
  data?: InputMaybe<AddFloorPlanFeedbackInput>;
};


export type MutationAddFloorPlanFeedbackWebArgs = {
  data?: InputMaybe<AddFloorPlanFeedbackWebInput>;
};


export type MutationDeleteFloorPlanArgs = {
  floorPlanId: Scalars['ID']['input'];
};


export type MutationDeleteFloorPlanWebArgs = {
  floorPlanId: Scalars['ID']['input'];
};


export type MutationGenerateAnnotationArgs = {
  input: GenerateAnnotationInput;
};


export type MutationGenerateAnnotationWebArgs = {
  input: GenerateAnnotationWebInput;
};


export type MutationLoginArgs = {
  data: LoginInputData;
};


export type MutationLoginWebArgs = {
  data: LoginWebInputData;
};


export type MutationRefreshTokenArgs = {
  data?: InputMaybe<RefreshTokenInput>;
};


export type MutationRefreshTokenWebArgs = {
  data?: InputMaybe<RefreshTokenWebInput>;
};


export type MutationUpdateAndSubmitAnnotationArgs = {
  data: UpdateAnnotationInput;
  floorPlanId: Scalars['ID']['input'];
};


export type MutationUpdateAndSubmitAnnotationWebArgs = {
  data: UpdateAnnotationWebInput;
  floorPlanId: Scalars['ID']['input'];
};


export type MutationUpdateFloorPlanArgs = {
  data?: InputMaybe<UpdateFloorPlanInput>;
};


export type MutationUpdateFloorPlanWebArgs = {
  data?: InputMaybe<UpdateFloorPlanWebInput>;
};


export type MutationUpdateUserArgs = {
  data?: InputMaybe<UpdateUserInput>;
};


export type MutationUpdateUserWebArgs = {
  data?: InputMaybe<UpdateUserWebInput>;
};


export type MutationUploadFloorPlanArgs = {
  data?: InputMaybe<UploadFloorPlanInput>;
};


export type MutationUploadFloorPlanWebArgs = {
  data?: InputMaybe<UploadFloorPlanWebInput>;
};

export type PropertyTypes = {
  __typename?: 'PropertyTypes';
  propertyName?: Maybe<Scalars['String']['output']>;
};

export type PropertyTypesResponse = {
  __typename?: 'PropertyTypesResponse';
  data?: Maybe<Array<Maybe<PropertyTypes>>>;
  message?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type PropertyTypesResponseWeb = {
  __typename?: 'PropertyTypesResponseWeb';
  data?: Maybe<Array<Maybe<PropertyTypes>>>;
  message?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type Query = {
  __typename?: 'Query';
  downloadFloorPlanReport?: Maybe<FloorPlanReportResponse>;
  downloadFloorPlanReportWeb?: Maybe<FloorPlanReportWebResponse>;
  getAllFloorPlanDetections?: Maybe<FloorPlanWithDetectionsResponse>;
  getAllFloorPlanDetectionsWeb?: Maybe<FloorPlanWithDetectionsWebResponse>;
  getAllPropertyTypes?: Maybe<PropertyTypesResponse>;
  getAllPropertyTypesWeb?: Maybe<PropertyTypesResponseWeb>;
  getColorCodes: ColorCodes;
  getColorCodesWeb: GetColorCodesWebResponse;
  getDetectionsByFloorPlan?: Maybe<FloorPlanWithDetectionsResponse>;
  getDetectionsByFloorPlanWeb?: Maybe<FloorPlanWithDetectionsWebResponse>;
  getFloorPlan?: Maybe<FloorPlan>;
  getFloorPlanDetectionTitles?: Maybe<FloorPlanDetectionTitlesResponse>;
  getFloorPlanStaticData?: Maybe<GetFloorPlanStaticDataResponse>;
  getFloorPlanStaticDataWeb?: Maybe<GetFloorPlanStaticDataResponse>;
  getFloorPlanUploadSignedUrl?: Maybe<SignedUrlResponse>;
  getFloorPlanWeb?: Maybe<FloorPlan>;
  getFloorPlans?: Maybe<FloorPlansResponse>;
  getFloorPlansWeb?: Maybe<FloorPlansWebResponse>;
  getImageSignedUrl?: Maybe<SignedUrlResponse>;
  getImageSignedUrlWeb?: Maybe<SignedUrlWebResponse>;
  getLoggedInUser?: Maybe<User>;
  getLoggedInUserWeb?: Maybe<User>;
  isPhoneNoExist?: Maybe<IsPhoneNoExistResponse>;
  isPhoneNoExistWeb?: Maybe<IsPhoneNoExistWebResponse>;
  validateBaseImage?: Maybe<ValidateBaseImageResponse>;
  validateBaseImageWeb?: Maybe<ValidateBaseImageWebResponse>;
};


export type QueryDownloadFloorPlanReportArgs = {
  floorPlanId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDownloadFloorPlanReportWebArgs = {
  floorPlanId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAllFloorPlanDetectionsArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetAllFloorPlanDetectionsWebArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetDetectionsByFloorPlanArgs = {
  data?: InputMaybe<GetDetectionsByFloorPlanInput>;
};


export type QueryGetDetectionsByFloorPlanWebArgs = {
  data?: InputMaybe<GetDetectionsByFloorPlanWebInput>;
};


export type QueryGetFloorPlanArgs = {
  floorPlanId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetFloorPlanDetectionTitlesArgs = {
  data?: InputMaybe<GetFloorPlanDetectionTitlesInput>;
};


export type QueryGetFloorPlanUploadSignedUrlArgs = {
  data?: InputMaybe<GetFloorPlanBaseImageUploadSignedUrlInput>;
};


export type QueryGetFloorPlanWebArgs = {
  floorPlanId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetFloorPlansArgs = {
  data?: InputMaybe<Filter>;
};


export type QueryGetFloorPlansWebArgs = {
  data?: InputMaybe<Filter>;
};


export type QueryGetImageSignedUrlArgs = {
  data?: InputMaybe<GetImageSignedUrlInput>;
};


export type QueryGetImageSignedUrlWebArgs = {
  data?: InputMaybe<GetImageSignedUrlWebInput>;
};


export type QueryIsPhoneNoExistArgs = {
  data: IsPhoneNoExistInput;
};


export type QueryIsPhoneNoExistWebArgs = {
  data: IsPhoneNoExistWebInput;
};


export type QueryValidateBaseImageArgs = {
  data?: InputMaybe<ValidateBaseImageInput>;
};


export type QueryValidateBaseImageWebArgs = {
  data?: InputMaybe<ValidateBaseImageWebInput>;
};

export type RefreshTokenInput = {
  refreshToken: Scalars['String']['input'];
};

export type RefreshTokenResponse = {
  __typename?: 'RefreshTokenResponse';
  accessToken?: Maybe<Scalars['String']['output']>;
};

export type RefreshTokenWebInput = {
  refreshToken: Scalars['String']['input'];
};

export type RefreshTokenWebResponse = {
  __typename?: 'RefreshTokenWebResponse';
  accessToken?: Maybe<Scalars['String']['output']>;
};

export enum S3PathEnum {
  FloorPlanBaseImage = 'FLOOR_PLAN_BASE_IMAGE',
  FloorPlanEntranceImage = 'FLOOR_PLAN_ENTRANCE_IMAGE',
  FloorPlanNorthDirectedImage = 'FLOOR_PLAN_NORTH_DIRECTED_IMAGE',
  UserAvatar = 'USER_AVATAR'
}

export enum SeverityEnum {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type SignedUrlResponse = {
  __typename?: 'SignedUrlResponse';
  key?: Maybe<Scalars['String']['output']>;
  signedUrl?: Maybe<Scalars['String']['output']>;
};

export type SignedUrlWebResponse = {
  __typename?: 'SignedUrlWebResponse';
  key?: Maybe<Scalars['String']['output']>;
  signedUrl?: Maybe<Scalars['String']['output']>;
};

export type SortBy = {
  field: Scalars['String']['input'];
  order: SortOrder;
};

export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type UpdateAndSubmitAnnotationResponse = {
  __typename?: 'UpdateAndSubmitAnnotationResponse';
  data?: Maybe<Annotation>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type UpdateAnnotationInput = {
  detections?: InputMaybe<Array<InputMaybe<AnnotationDetectionInput>>>;
  parentTypes?: InputMaybe<Array<InputMaybe<AnnotationDetectionInput>>>;
};

export type UpdateAnnotationWebInput = {
  detections?: InputMaybe<Array<InputMaybe<AnnotationDetectionInput>>>;
  parentTypes?: InputMaybe<Array<InputMaybe<AnnotationDetectionInput>>>;
};

export type UpdateFloorPlanInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  angle?: InputMaybe<Scalars['Float']['input']>;
  baseImage?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<EntranceDirectionEnum>;
  entranceImage?: InputMaybe<Scalars['String']['input']>;
  floorNumber?: InputMaybe<Scalars['Int']['input']>;
  floorPlanId: Scalars['ID']['input'];
  height?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  northDirectedImage?: InputMaybe<Scalars['String']['input']>;
  propertyType?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
  xAxis?: InputMaybe<Scalars['Float']['input']>;
  yAxis?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateFloorPlanWebInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  angle?: InputMaybe<Scalars['Float']['input']>;
  baseImage?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<EntranceDirectionEnum>;
  entranceImage?: InputMaybe<Scalars['String']['input']>;
  floorNumber?: InputMaybe<Scalars['Int']['input']>;
  floorPlanId: Scalars['ID']['input'];
  height?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  northDirectedImage?: InputMaybe<Scalars['String']['input']>;
  propertyType?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
  xAxis?: InputMaybe<Scalars['Float']['input']>;
  yAxis?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateUserInput = {
  avatar?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  otpLessVerificationToken?: InputMaybe<Scalars['String']['input']>;
  phoneNo?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserWebInput = {
  avatar?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  otpLessVerificationToken?: InputMaybe<Scalars['String']['input']>;
  phoneNo?: InputMaybe<Scalars['String']['input']>;
};

export type UploadFloorPlanInput = {
  baseImage: Scalars['String']['input'];
  floorNumber: Scalars['Int']['input'];
  height: Scalars['Float']['input'];
  name: Scalars['String']['input'];
  propertyType: Scalars['String']['input'];
  width: Scalars['Float']['input'];
};

export type UploadFloorPlanWebInput = {
  baseImage: Scalars['String']['input'];
  floorNumber: Scalars['Int']['input'];
  height: Scalars['Float']['input'];
  name: Scalars['String']['input'];
  propertyType: Scalars['String']['input'];
  width: Scalars['Float']['input'];
};

export type User = {
  __typename?: 'User';
  avatar?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isRegistered?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNo?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type UserResponse = {
  __typename?: 'UserResponse';
  data?: Maybe<User>;
  message?: Maybe<Scalars['String']['output']>;
};

export type UserWebResponse = {
  __typename?: 'UserWebResponse';
  data?: Maybe<User>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ValidateBaseImageInput = {
  baseImage: Scalars['String']['input'];
};

export type ValidateBaseImageResponse = {
  __typename?: 'ValidateBaseImageResponse';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ValidateBaseImageWebInput = {
  baseImage: Scalars['String']['input'];
};

export type ValidateBaseImageWebResponse = {
  __typename?: 'ValidateBaseImageWebResponse';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeviceInfo = {
  appVersion: Scalars['String']['input'];
  deviceId: Scalars['String']['input'];
  deviceModel: Scalars['String']['input'];
  os: Scalars['String']['input'];
  osVersion: Scalars['String']['input'];
};

export type UpdateAndSubmitAnnotationWebMutationVariables = Exact<{
  data: UpdateAnnotationWebInput;
  floorPlanId: Scalars['ID']['input'];
}>;


export type UpdateAndSubmitAnnotationWebMutation = { __typename?: 'Mutation', updateAndSubmitAnnotationWeb?: { __typename?: 'UpdateAndSubmitAnnotationResponse', status?: string | null } | null };

export type GetFloorPlanWebQueryVariables = Exact<{
  floorPlanId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetFloorPlanWebQuery = { __typename?: 'Query', getFloorPlanWeb?: { __typename?: 'FloorPlan', id?: string | null, name?: string | null, propertyType?: string | null, status?: FloorPlanEnum | null, floorNumber?: number | null, assets?: Array<{ __typename?: 'Asset', angle?: number | null, category?: CategoryEnum | null, direction?: EntranceDirectionEnum | null, height?: number | null, id?: string | null, key?: string | null, width?: number | null } | null> | null, annotation?: { __typename?: 'Annotation', detections?: Array<{ __typename?: 'AnnotationDetection', bbox?: Array<number | null> | null, childID?: string | null, childType?: string | null, confidence?: number | null, parentID?: string | null, parentType?: string | null, title?: string | null } | null> | null, parentTypes?: Array<{ __typename?: 'AnnotationParentType', parentID?: string | null, parentType?: string | null, title?: string | null, bbox?: Array<number | null> | null } | null> | null } | null } | null };

export type DataQueryVariables = Exact<{ [key: string]: never; }>;


export type DataQuery = { __typename?: 'Query', getFloorPlanStaticDataWeb?: { __typename?: 'GetFloorPlanStaticDataResponse', data?: Array<{ __typename?: 'FloorPlanStaticData', allowedChildrenElements?: Array<string | null> | null, allowedParentElements?: Array<string | null> | null, description?: string | null, title?: string | null, type?: string | null } | null> | null } | null };

export type LoginWebMutationVariables = Exact<{
  data: LoginWebInputData;
}>;


export type LoginWebMutation = { __typename?: 'Mutation', loginWeb?: { __typename?: 'LoginWebResponse', message?: string | null, accessToken?: string | null, refreshToken?: string | null, data?: { __typename?: 'User', firstName?: string | null, lastName?: string | null, email?: string | null, phoneNo?: string | null, isRegistered?: boolean | null, countryCode?: string | null, avatar?: string | null } | null } | null };

export type RefreshTokenWebMutationVariables = Exact<{
  data?: InputMaybe<RefreshTokenWebInput>;
}>;


export type RefreshTokenWebMutation = { __typename?: 'Mutation', refreshTokenWeb?: { __typename?: 'RefreshTokenWebResponse', accessToken?: string | null } | null };

export type UpdateUserMutationVariables = Exact<{
  data?: InputMaybe<UpdateUserWebInput>;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUserWeb?: { __typename?: 'UserWebResponse', message?: string | null, data?: { __typename?: 'User', firstName?: string | null, lastName?: string | null, phoneNo?: string | null, email?: string | null, avatar?: string | null, countryCode?: string | null, isRegistered?: boolean | null } | null } | null };

export type GetLoggedInUserWebQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLoggedInUserWebQuery = { __typename?: 'Query', getLoggedInUserWeb?: { __typename?: 'User', firstName?: string | null, lastName?: string | null, phoneNo?: string | null, email?: string | null, avatar?: string | null, id?: string | null, countryCode?: string | null } | null };

export type DeleteAccountWebMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteAccountWebMutation = { __typename?: 'Mutation', deleteAccountWeb?: { __typename?: 'CommonMessageResponse', message?: string | null } | null };

export type MutationMutationVariables = Exact<{ [key: string]: never; }>;


export type MutationMutation = { __typename?: 'Mutation', logoutWeb?: { __typename?: 'CommonMessageResponse', message?: string | null, status?: string | null } | null };

export type GetImageSignedUrlWebQueryVariables = Exact<{
  data?: InputMaybe<GetImageSignedUrlWebInput>;
}>;


export type GetImageSignedUrlWebQuery = { __typename?: 'Query', getImageSignedUrlWeb?: { __typename?: 'SignedUrlWebResponse', key?: string | null, signedUrl?: string | null } | null };

export type IsPhoneNoExistWebQueryVariables = Exact<{
  data: IsPhoneNoExistWebInput;
}>;


export type IsPhoneNoExistWebQuery = { __typename?: 'Query', isPhoneNoExistWeb?: { __typename?: 'IsPhoneNoExistWebResponse', phoneNoExist?: boolean | null } | null };

export type AddFloorPlanFeedbackWebMutationVariables = Exact<{
  data?: InputMaybe<AddFloorPlanFeedbackWebInput>;
}>;


export type AddFloorPlanFeedbackWebMutation = { __typename?: 'Mutation', addFloorPlanFeedbackWeb?: { __typename?: 'CommonMessageResponse', status?: string | null } | null };

export type DeleteFloorPlanMutationVariables = Exact<{
  floorPlanId: Scalars['ID']['input'];
}>;


export type DeleteFloorPlanMutation = { __typename?: 'Mutation', deleteFloorPlan?: { __typename?: 'CommonMessageResponse', status?: string | null } | null };

export type GetFloorPlansWebQueryVariables = Exact<{
  data?: InputMaybe<Filter>;
}>;


export type GetFloorPlansWebQuery = { __typename?: 'Query', getFloorPlansWeb?: { __typename?: 'FloorPlansWebResponse', total?: number | null, data?: Array<{ __typename?: 'FloorPlan', id?: string | null, name?: string | null, propertyType?: string | null, resultScore?: number | null, status?: FloorPlanEnum | null, totalScore?: number | null, floorNumber?: number | null, companyName?: string | null, address?: string | null, createdAt?: any | null, assets?: Array<{ __typename?: 'Asset', angle?: number | null, category?: CategoryEnum | null, createdAt?: any | null, direction?: EntranceDirectionEnum | null, height?: number | null, id?: string | null, key?: string | null, updatedAt?: any | null, width?: number | null, xAxis?: number | null, yAxis?: number | null } | null> | null } | null> | null } | null };

export type ConfidenceColorsQueryVariables = Exact<{ [key: string]: never; }>;


export type ConfidenceColorsQuery = { __typename?: 'Query', getColorCodesWeb: { __typename?: 'GetColorCodesWebResponse', confidenceColors: { __typename?: 'Color', high: string, low: string, medium: string }, severityColors: { __typename?: 'Color', high: string, low: string, medium: string } } };

export type GetDetectionsByFloorPlanWebQueryVariables = Exact<{
  data?: InputMaybe<GetDetectionsByFloorPlanWebInput>;
}>;


export type GetDetectionsByFloorPlanWebQuery = { __typename?: 'Query', getDetectionsByFloorPlanWeb?: { __typename?: 'FloorPlanWithDetectionsWebResponse', data?: Array<{ __typename?: 'FloorPlanDetection', parentId?: string | null, confidence?: number | null, createdAt?: any | null, description?: string | null, detectionImage?: string | null, direction?: CardinalDirectionEnum | null, id?: string | null, issue?: boolean | null, resultScore?: number | null, severity?: SeverityEnum | null, title?: string | null, totalScore?: number | null, updatedAt?: any | null, bbox?: Array<number | null> | null, childId?: string | null, childType?: string | null } | null> | null } | null };

export type DownloadFloorPlanReportWebQueryVariables = Exact<{
  floorPlanId?: InputMaybe<Scalars['String']['input']>;
}>;


export type DownloadFloorPlanReportWebQuery = { __typename?: 'Query', downloadFloorPlanReportWeb?: { __typename?: 'FloorPlanReportWebResponse', message?: string | null, url?: string | null } | null };

export type UploadFloorPlanWebMutationVariables = Exact<{
  data?: InputMaybe<UploadFloorPlanWebInput>;
}>;


export type UploadFloorPlanWebMutation = { __typename?: 'Mutation', uploadFloorPlanWeb?: { __typename?: 'FloorPlanWebResponse', message?: string | null, data?: { __typename?: 'FloorPlan', id?: string | null, name?: string | null, propertyType?: string | null, floorNumber?: number | null, assets?: Array<{ __typename?: 'Asset', key?: string | null, width?: number | null, id?: string | null, category?: CategoryEnum | null, height?: number | null } | null> | null } | null } | null };

export type UpdateFloorPlanWebMutationVariables = Exact<{
  data?: InputMaybe<UpdateFloorPlanWebInput>;
}>;


export type UpdateFloorPlanWebMutation = { __typename?: 'Mutation', updateFloorPlanWeb?: { __typename?: 'FloorPlanWebResponse', message?: string | null, data?: { __typename?: 'FloorPlan', resultScore?: number | null, address?: string | null, companyName?: string | null, id?: string | null, name?: string | null, propertyType?: string | null, floorNumber?: number | null, assets?: Array<{ __typename?: 'Asset', angle?: number | null, key?: string | null, id?: string | null, category?: CategoryEnum | null, width?: number | null, height?: number | null } | null> | null } | null } | null };

export type GenerateAnnotationWebMutationVariables = Exact<{
  input: GenerateAnnotationWebInput;
}>;


export type GenerateAnnotationWebMutation = { __typename?: 'Mutation', generateAnnotationWeb?: { __typename?: 'GenerateAnnotationWebResponse', message?: string | null, status?: string | null } | null };

export type ValidateBaseImageWebQueryVariables = Exact<{
  data?: InputMaybe<ValidateBaseImageWebInput>;
}>;


export type ValidateBaseImageWebQuery = { __typename?: 'Query', validateBaseImageWeb?: { __typename?: 'ValidateBaseImageWebResponse', message?: string | null, success?: boolean | null } | null };

export type GetAllPropertyTypesWebQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllPropertyTypesWebQuery = { __typename?: 'Query', getAllPropertyTypesWeb?: { __typename?: 'PropertyTypesResponseWeb', total?: number | null, data?: Array<{ __typename?: 'PropertyTypes', propertyName?: string | null } | null> | null } | null };


export const UpdateAndSubmitAnnotationWebDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAndSubmitAnnotationWeb"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAnnotationWebInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"floorPlanId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAndSubmitAnnotationWeb"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"floorPlanId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"floorPlanId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<UpdateAndSubmitAnnotationWebMutation, UpdateAndSubmitAnnotationWebMutationVariables>;
export const GetFloorPlanWebDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFloorPlanWeb"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"floorPlanId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getFloorPlanWeb"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"floorPlanId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"floorPlanId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"propertyType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"floorNumber"}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"angle"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"direction"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"width"}}]}},{"kind":"Field","name":{"kind":"Name","value":"annotation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"detections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bbox"}},{"kind":"Field","name":{"kind":"Name","value":"childID"}},{"kind":"Field","name":{"kind":"Name","value":"childType"}},{"kind":"Field","name":{"kind":"Name","value":"confidence"}},{"kind":"Field","name":{"kind":"Name","value":"parentID"}},{"kind":"Field","name":{"kind":"Name","value":"parentType"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parentID"}},{"kind":"Field","name":{"kind":"Name","value":"parentType"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"bbox"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetFloorPlanWebQuery, GetFloorPlanWebQueryVariables>;
export const DataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getFloorPlanStaticDataWeb"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allowedChildrenElements"}},{"kind":"Field","name":{"kind":"Name","value":"allowedParentElements"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]} as unknown as DocumentNode<DataQuery, DataQueryVariables>;
export const LoginWebDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LoginWeb"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LoginWebInputData"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loginWeb"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"accessToken"}},{"kind":"Field","name":{"kind":"Name","value":"refreshToken"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNo"}},{"kind":"Field","name":{"kind":"Name","value":"isRegistered"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}}]}}]}}]} as unknown as DocumentNode<LoginWebMutation, LoginWebMutationVariables>;
export const RefreshTokenWebDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RefreshTokenWeb"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"RefreshTokenWebInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"refreshTokenWeb"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessToken"}}]}}]}}]} as unknown as DocumentNode<RefreshTokenWebMutation, RefreshTokenWebMutationVariables>;
export const UpdateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateUserWebInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserWeb"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNo"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"isRegistered"}}]}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<UpdateUserMutation, UpdateUserMutationVariables>;
export const GetLoggedInUserWebDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLoggedInUserWeb"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getLoggedInUserWeb"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNo"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}}]}}]} as unknown as DocumentNode<GetLoggedInUserWebQuery, GetLoggedInUserWebQueryVariables>;
export const DeleteAccountWebDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteAccountWeb"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteAccountWeb"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<DeleteAccountWebMutation, DeleteAccountWebMutationVariables>;
export const MutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Mutation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logoutWeb"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<MutationMutation, MutationMutationVariables>;
export const GetImageSignedUrlWebDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetImageSignedUrlWeb"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"GetImageSignedUrlWebInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getImageSignedUrlWeb"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"signedUrl"}}]}}]}}]} as unknown as DocumentNode<GetImageSignedUrlWebQuery, GetImageSignedUrlWebQueryVariables>;
export const IsPhoneNoExistWebDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"IsPhoneNoExistWeb"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"IsPhoneNoExistWebInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isPhoneNoExistWeb"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNoExist"}}]}}]}}]} as unknown as DocumentNode<IsPhoneNoExistWebQuery, IsPhoneNoExistWebQueryVariables>;
export const AddFloorPlanFeedbackWebDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddFloorPlanFeedbackWeb"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AddFloorPlanFeedbackWebInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addFloorPlanFeedbackWeb"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<AddFloorPlanFeedbackWebMutation, AddFloorPlanFeedbackWebMutationVariables>;
export const DeleteFloorPlanDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteFloorPlan"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"floorPlanId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteFloorPlan"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"floorPlanId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"floorPlanId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<DeleteFloorPlanMutation, DeleteFloorPlanMutationVariables>;
export const GetFloorPlansWebDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFloorPlansWeb"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getFloorPlansWeb"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"propertyType"}},{"kind":"Field","name":{"kind":"Name","value":"resultScore"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"totalScore"}},{"kind":"Field","name":{"kind":"Name","value":"floorNumber"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"angle"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"direction"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"xAxis"}},{"kind":"Field","name":{"kind":"Name","value":"yAxis"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]} as unknown as DocumentNode<GetFloorPlansWebQuery, GetFloorPlansWebQueryVariables>;
export const ConfidenceColorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ConfidenceColors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getColorCodesWeb"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"confidenceColors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"high"}},{"kind":"Field","name":{"kind":"Name","value":"low"}},{"kind":"Field","name":{"kind":"Name","value":"medium"}}]}},{"kind":"Field","name":{"kind":"Name","value":"severityColors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"high"}},{"kind":"Field","name":{"kind":"Name","value":"low"}},{"kind":"Field","name":{"kind":"Name","value":"medium"}}]}}]}}]}}]} as unknown as DocumentNode<ConfidenceColorsQuery, ConfidenceColorsQueryVariables>;
export const GetDetectionsByFloorPlanWebDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDetectionsByFloorPlanWeb"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"GetDetectionsByFloorPlanWebInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getDetectionsByFloorPlanWeb"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"confidence"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"detectionImage"}},{"kind":"Field","name":{"kind":"Name","value":"direction"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"issue"}},{"kind":"Field","name":{"kind":"Name","value":"resultScore"}},{"kind":"Field","name":{"kind":"Name","value":"severity"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"totalScore"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"bbox"}},{"kind":"Field","name":{"kind":"Name","value":"childId"}},{"kind":"Field","name":{"kind":"Name","value":"childType"}}]}}]}}]}}]} as unknown as DocumentNode<GetDetectionsByFloorPlanWebQuery, GetDetectionsByFloorPlanWebQueryVariables>;
export const DownloadFloorPlanReportWebDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DownloadFloorPlanReportWeb"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"floorPlanId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"downloadFloorPlanReportWeb"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"floorPlanId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"floorPlanId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<DownloadFloorPlanReportWebQuery, DownloadFloorPlanReportWebQueryVariables>;
export const UploadFloorPlanWebDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UploadFloorPlanWeb"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UploadFloorPlanWebInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadFloorPlanWeb"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"propertyType"}},{"kind":"Field","name":{"kind":"Name","value":"floorNumber"}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<UploadFloorPlanWebMutation, UploadFloorPlanWebMutationVariables>;
export const UpdateFloorPlanWebDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateFloorPlanWeb"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateFloorPlanWebInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateFloorPlanWeb"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resultScore"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"propertyType"}},{"kind":"Field","name":{"kind":"Name","value":"floorNumber"}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"angle"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<UpdateFloorPlanWebMutation, UpdateFloorPlanWebMutationVariables>;
export const GenerateAnnotationWebDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GenerateAnnotationWeb"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GenerateAnnotationWebInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generateAnnotationWeb"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<GenerateAnnotationWebMutation, GenerateAnnotationWebMutationVariables>;
export const ValidateBaseImageWebDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ValidateBaseImageWeb"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ValidateBaseImageWebInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validateBaseImageWeb"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<ValidateBaseImageWebQuery, ValidateBaseImageWebQueryVariables>;
export const GetAllPropertyTypesWebDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllPropertyTypesWeb"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAllPropertyTypesWeb"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"propertyName"}}]}}]}}]}}]} as unknown as DocumentNode<GetAllPropertyTypesWebQuery, GetAllPropertyTypesWebQueryVariables>;